import { useEffect, useState } from "react";
import axios from "axios";
import AsyncSelect from "react-select/async"

import { getBaseUrl } from "./axios.service";
import { formatGoogleLocation, formatGooglePredictions } from "./LogicHelper";
import { Loading } from "./constants";
import { quoteStyle } from "./CustomStyles";
import { DebounceHook } from "./DebounceHook";
import toast from "react-hot-toast";

const MapSelect = ({ placeholder, setLocation, type, value }) => {
  const [debounceField, setDebounceField] = useState("");
  const [debounceState, setDebounceState] = useState(false);
  const debounceText = DebounceHook(debounceField, 350);

  useEffect(() => {
    if (debounceField && debounceText) setDebounceState(true);
  }, [debounceField, debounceText]);

  const resetDebounceForm = () => {
    setDebounceState(false);
    setDebounceField("");
  };

  const fetchPredictions = async inputValue => {
    let response = await axios.get(`${getBaseUrl().web}/booking-service/maps/autocomplete-search-by-text/?search_text=${inputValue}`);
    if (response.status === Loading.OK) return formatGooglePredictions(response.data["data"]);
  };

  const getLocationData = async selectedValue => {
    const response = await axios.get(`${getBaseUrl().web}/booking-service/maps/search-place-by-id/?place_id=${selectedValue}`);
    if (response.status === Loading.OK) return formatGoogleLocation(response.data["data"]);
  };

  const loadOptions = async (inputValue, callback) => {
    setDebounceField(inputValue);
    if (!debounceState) return callback([]);
    else {
      const predictions = await fetchPredictions(debounceText);
      callback(predictions);
    }
  };

  const onSelectOption = async selectedOption => {
    if (!selectedOption) setLocation({});
    else {
      if (selectedOption && selectedOption["place_id"]) {
        let locationObject = await getLocationData(selectedOption["place_id"]);
        resetDebounceForm();
        if (type === "DESTINATION") locationObject.stops = { number: 0, stopovers: [] };
        setLocation(locationObject);
      } else return toast.error("We are unable to resove this location, Please select another location that is approximately close to your choice of location");
    }
  };


  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      menuPlacement="bottom"
      isClearable={true}
      loadOptions={loadOptions}
      onChange={option => onSelectOption(option)}
      styles={quoteStyle}
      placeholder={placeholder}
      value={value}
      className="form-field__input__select bg-white"
      noOptionsMessage={() => "Type to search of a location"}
    />
  );
}

export default MapSelect